import styled, { keyframes } from 'styled-components'

import { IconSearch } from '@avantstay/backoffice-vectors'

import { _M_Normal, _XL_Bold, _XS_Medium, _XS_Normal, mainColors, medias } from '../../styles'
import { Button } from '../Button'
import { Loading } from '../Loading'
import { Modal } from '../Modal'
import { CloseModalIcon } from '../Modal/Modal.styles'

export const ICON_SIZE = 24

const CARD_WIDTH = 115
const CARDS_PER_ROW = 5

const animFadeIn = keyframes`
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`

export const StyledModal = styled(Modal)`
  div[class*='CardStyled'] {
    display: flex;
    flex-direction: column;
    min-width: calc(100% - 40px);
    max-width: calc(100% - 40px);
    padding: 0 24px 24px 24px;
    gap: 24px;
    border-radius: 4px;
    border-bottom: 1px solid ${mainColors.neutralMedium};

    ${CloseModalIcon} {
      right: 0;
      left: auto;
    }

    ${medias.MD_SCREEN`
      min-width: 600px;
    `}
  }
`

export const ModalTitle = styled.h2`
  ${_XL_Bold};
  color: ${mainColors.primaryMedium};
`

export const TextFieldWrapper = styled.div`
  position: relative;
  input {
    line-height: 28px;
    padding-left: 28px;
  }
`
export const IconSearchFilter = styled(IconSearch).attrs({ width: 16, height: 16 })`
  position: absolute;
  z-index: 1;
  inset: 10px auto auto 10px;
  color: ${mainColors.neutralExtraDark};
`

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`

export const SectionTitle = styled.h4`
  display: flex;
  justify-content: flex-start;
  color: ${mainColors.neutralExtremelyDark};
  ${_XS_Medium};
`

export const SectionLoading = styled(Loading)`
  min-height: 250px;
  padding-bottom: 50px;
`

export const SectionEmpty = styled.div`
  width: 100%;
  padding: 10px 0 20px;
  text-align: center;
  color: ${mainColors.neutralDark};
  ${_M_Normal};
`

export const GridCards = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  overflow-y: visible;

  ${medias.MD_SCREEN`
    display: grid;
    grid-template-columns: repeat(${CARDS_PER_ROW}, ${CARD_WIDTH}px);
  `}
`

export const CopyIconFrame = styled.div`
  width: ${ICON_SIZE}px;
  height: ${ICON_SIZE}px;
  opacity: 0;

  > * {
    display: flex;
    align-items: center;
    justify-content: center;

    svg {
      color: ${mainColors.accentMedium};
      min-width: ${ICON_SIZE}px;
      max-width: ${ICON_SIZE}px;
      min-height: ${ICON_SIZE}px;
      max-height: ${ICON_SIZE}px;
      padding: 6px;
      border-radius: 4px;
      background-color: ${mainColors.accentExtremelyLight};
    }
  }

  &:hover {
    opacity: 1;

    svg {
      color: ${mainColors.accentMedium};
    }
  }
`

export const CardButton = styled(Button.Flat)`
  min-width: ${CARD_WIDTH}px;
  max-width: ${CARD_WIDTH}px;
  min-height: 100px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 12px;
  border: 1px solid ${mainColors.neutralMedium};
  border-radius: 8px;
  transition: border-color 0.2s;
  &:not([disabled]) {
    animation: ${animFadeIn} ease-out 0.3s forwards;
  }
  &[disabled] {
    transition: none;
    background-color: ${mainColors.neutralLight};
    filter: grayscale(100%) blur(3px);
    opacity: 0.3;
  }
  &:not([disabled]):hover {
    transition: none;
    border-color: ${mainColors.neutralDark};
    box-shadow: 0 3px 50px ${mainColors.neutralLight};
    &:active {
      box-shadow: 0 2px 20px ${mainColors.neutralMedium};
      transform: translateY(1px);
    }
  }

  &:hover {
    ${CopyIconFrame} {
      opacity: 1;
    }
  }
`

export const LinkHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  width: 100%;
  margin-bottom: auto;
`

export const Text = styled.div`
  width: 100%;
  text-align: left;
  line-height: 18px;
  ${_XS_Normal};
  color: ${mainColors.black};
`

export const LinkIconFrame = styled.div`
  width: ${ICON_SIZE}px;
  height: ${ICON_SIZE}px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 6px;
  background-color: ${mainColors.neutralMedium};

  svg {
    color: ${mainColors.neutralExtraDark};
  }
`
